import {Component, OnInit} from '@angular/core';
import {RouterLink, RouterLinkActive} from "@angular/router";

/** Navigation bar at the top of the patient page */
@Component({
  selector: 'app-patient-nav',
	imports: [
		RouterLink,
		RouterLinkActive
	],
  templateUrl: './patient-nav.component.html',
  styleUrl: './patient-nav.component.scss'
})
export class PatientNavComponent implements OnInit{
	/** Link descriptors in the navigation */
	links:NavLink[] = [
		{
			text: 'Overview',
			routerLink: 'overview'
		},
		{
			text: 'Info',
			routerLink: 'info'
		},
		{
			text: 'Docs',
			routerLink: 'docs'
		},
		{
			text: 'ID',
			routerLink: 'id'
		},
		{
			text: 'Insurance',
			routerLink: 'insurance'
		},
		{
			text: 'Payment',
			routerLink: 'payment'
		}
	]

	constructor() {
	}

	ngOnInit():void {
	}
}

/** A navigation link description */
interface NavLink {
	/** The text of the link */
	text:string;

	/** The route of the link */
	routerLink:string;
}
